import { Descriptions, Popover, Spin, Typography } from "antd"
import React, { useEffect, useState } from "react"
import axiosInstance from "../../axios/axiosConfig"

const { Link } = Typography

export default function ShowKnifeInfo({ props }) {
  const { knifeCode } = props

  const [currentKnife, setCurrentKnife] = useState({})
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      if (knifeCode === "New Knife") {
        setLoading(false)
        setCurrentKnife({
          width: "new knife",
          height: "new knife",
          rowss: "new knife",
          spaceBetweenRows: "new knife",
          "Z.raports": "new knife",
          gapRaport: "new knife",
        })
      } else {
        try {
          const response = await axiosInstance.get(
            `/api/searchByCode?code=${encodeURIComponent(knifeCode)}`
          )
          console.log(response.data) // Handle the response data
          setCurrentKnife(response.data)
        } catch (error) {
          console.error("Failed to fetch data:", error)
        } finally {
          setLoading(false)
        }
      }
    }

    fetchData()
  }, [knifeCode])

  const content = (
    <div>
      <Descriptions column={1} style={{ width: "200px" }}>
        <Descriptions.Item label="Knife Width">{currentKnife.width}</Descriptions.Item>
        <Descriptions.Item label="Knife Height">{currentKnife.height}</Descriptions.Item>
        <Descriptions.Item label="Rows">{currentKnife.rowss}</Descriptions.Item>
        <Descriptions.Item label="Space Between Rows">
          {currentKnife.spaceBetweenRows}
        </Descriptions.Item>
        <Descriptions.Item label="Z Raport">{currentKnife.Z_raports}</Descriptions.Item>
        <Descriptions.Item label="Gap Raport">{currentKnife.gapRaport}</Descriptions.Item>
      </Descriptions>
    </div>
  )

  return (
    <div>
      <Popover content={loading ? <Spin /> : content} title={knifeCode} trigger="click">
        <Link>{knifeCode}</Link>
      </Popover>
    </div>
  )
}
